module.exports = __webpack_public_path__ + "img/vannforekomster.28435582.jpg";